/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlActionChatops } from './ControlActionChatops';
import {
    ControlActionChatopsFromJSON,
    ControlActionChatopsFromJSONTyped,
    ControlActionChatopsToJSON,
} from './ControlActionChatops';
import type { ControlActionContainWithUser } from './ControlActionContainWithUser';
import {
    ControlActionContainWithUserFromJSON,
    ControlActionContainWithUserFromJSONTyped,
    ControlActionContainWithUserToJSON,
} from './ControlActionContainWithUser';
import type { ControlCategory3 } from './ControlCategory3';
import {
    ControlCategory3FromJSON,
    ControlCategory3FromJSONTyped,
    ControlCategory3ToJSON,
} from './ControlCategory3';
import type { ControlContainment } from './ControlContainment';
import {
    ControlContainmentFromJSON,
    ControlContainmentFromJSONTyped,
    ControlContainmentToJSON,
} from './ControlContainment';
import type { ControlDirectoryUser } from './ControlDirectoryUser';
import {
    ControlDirectoryUserFromJSON,
    ControlDirectoryUserFromJSONTyped,
    ControlDirectoryUserToJSON,
} from './ControlDirectoryUser';
import type { ControlDomain } from './ControlDomain';
import {
    ControlDomainFromJSON,
    ControlDomainFromJSONTyped,
    ControlDomainToJSON,
} from './ControlDomain';
import type { ControlEndpoint } from './ControlEndpoint';
import {
    ControlEndpointFromJSON,
    ControlEndpointFromJSONTyped,
    ControlEndpointToJSON,
} from './ControlEndpoint';
import type { ControlFile } from './ControlFile';
import {
    ControlFileFromJSON,
    ControlFileFromJSONTyped,
    ControlFileToJSON,
} from './ControlFile';
import type { ControlFileRisk } from './ControlFileRisk';
import {
    ControlFileRiskFromJSON,
    ControlFileRiskFromJSONTyped,
    ControlFileRiskToJSON,
} from './ControlFileRisk';
import type { ControlIP } from './ControlIP';
import {
    ControlIPFromJSON,
    ControlIPFromJSONTyped,
    ControlIPToJSON,
} from './ControlIP';
import type { ControlIntegrationPlatform1 } from './ControlIntegrationPlatform1';
import {
    ControlIntegrationPlatform1FromJSON,
    ControlIntegrationPlatform1FromJSONTyped,
    ControlIntegrationPlatform1ToJSON,
} from './ControlIntegrationPlatform1';
import type { ControlJSONLog } from './ControlJSONLog';
import {
    ControlJSONLogFromJSON,
    ControlJSONLogFromJSONTyped,
    ControlJSONLogToJSON,
} from './ControlJSONLog';
import type { ControlLocation } from './ControlLocation';
import {
    ControlLocationFromJSON,
    ControlLocationFromJSONTyped,
    ControlLocationToJSON,
} from './ControlLocation';
import type { ControlProcess } from './ControlProcess';
import {
    ControlProcessFromJSON,
    ControlProcessFromJSONTyped,
    ControlProcessToJSON,
} from './ControlProcess';
import type { ControlSeverity5 } from './ControlSeverity5';
import {
    ControlSeverity5FromJSON,
    ControlSeverity5FromJSONTyped,
    ControlSeverity5ToJSON,
} from './ControlSeverity5';
import type { ControlStatus3 } from './ControlStatus3';
import {
    ControlStatus3FromJSON,
    ControlStatus3FromJSONTyped,
    ControlStatus3ToJSON,
} from './ControlStatus3';
import type { ControlUserAgent } from './ControlUserAgent';
import {
    ControlUserAgentFromJSON,
    ControlUserAgentFromJSONTyped,
    ControlUserAgentToJSON,
} from './ControlUserAgent';
import type { ControlVerdict4 } from './ControlVerdict4';
import {
    ControlVerdict4FromJSON,
    ControlVerdict4FromJSONTyped,
    ControlVerdict4ToJSON,
} from './ControlVerdict4';
import type { ControlVerdictRule } from './ControlVerdictRule';
import {
    ControlVerdictRuleFromJSON,
    ControlVerdictRuleFromJSONTyped,
    ControlVerdictRuleToJSON,
} from './ControlVerdictRule';

/**
 * 
 * @export
 * @interface ControlDetectionWithEntities
 */
export interface ControlDetectionWithEntities {
    /**
     * 
     * @type {string}
     * @memberof ControlDetectionWithEntities
     */
    actionSlug?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlDetectionWithEntities
     */
    autoClosed?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlDetectionWithEntities
     */
    autoContained?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlDetectionWithEntities
     */
    caseId?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDetectionWithEntities
     */
    caseSid?: string;
    /**
     * 
     * @type {ControlCategory3}
     * @memberof ControlDetectionWithEntities
     */
    category: ControlCategory3;
    /**
     * 
     * @type {Array<ControlActionChatops>}
     * @memberof ControlDetectionWithEntities
     */
    chatOpsActions: Array<ControlActionChatops>;
    /**
     * 
     * @type {boolean}
     * @memberof ControlDetectionWithEntities
     */
    chatOpsTest: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlDetectionWithEntities
     */
    chatOpsTestEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDetectionWithEntities
     */
    chatOpsTestPhoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDetectionWithEntities
     */
    closedAt?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlDetectionWithEntities
     */
    containOnChatOpsFailure: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlDetectionWithEntities
     */
    contained: boolean;
    /**
     * 
     * @type {Array<ControlActionContainWithUser>}
     * @memberof ControlDetectionWithEntities
     */
    containmentActions: Array<ControlActionContainWithUser>;
    /**
     * 
     * @type {Array<ControlContainment>}
     * @memberof ControlDetectionWithEntities
     */
    containments: Array<ControlContainment>;
    /**
     * 
     * @type {boolean}
     * @memberof ControlDetectionWithEntities
     */
    containsHVA: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlDetectionWithEntities
     */
    containsVIP: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlDetectionWithEntities
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDetectionWithEntities
     */
    customDetectionId?: string;
    /**
     * 
     * @type {Array<ControlDirectoryUser>}
     * @memberof ControlDetectionWithEntities
     */
    directory: Array<ControlDirectoryUser>;
    /**
     * 
     * @type {Array<ControlDomain>}
     * @memberof ControlDetectionWithEntities
     */
    domains: Array<ControlDomain>;
    /**
     * 
     * @type {string}
     * @memberof ControlDetectionWithEntities
     */
    duplicateDetectionId?: string;
    /**
     * 
     * @type {Array<ControlEndpoint>}
     * @memberof ControlDetectionWithEntities
     */
    endpoints: Array<ControlEndpoint>;
    /**
     * 
     * @type {string}
     * @memberof ControlDetectionWithEntities
     */
    escalatedAt?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlDetectionWithEntities
     */
    excludeFromMeans: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlDetectionWithEntities
     */
    excluded: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlDetectionWithEntities
     */
    exclusionId?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDetectionWithEntities
     */
    exclusionSid?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDetectionWithEntities
     */
    externalCustomDetectionId?: string;
    /**
     * 
     * @type {ControlFileRisk}
     * @memberof ControlDetectionWithEntities
     */
    fileRisk: ControlFileRisk;
    /**
     * 
     * @type {Array<ControlFile>}
     * @memberof ControlDetectionWithEntities
     */
    files: Array<ControlFile>;
    /**
     * 
     * @type {boolean}
     * @memberof ControlDetectionWithEntities
     */
    firstRun: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlDetectionWithEntities
     */
    groups?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDetectionWithEntities
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDetectionWithEntities
     */
    integrationId?: string;
    /**
     * 
     * @type {ControlIntegrationPlatform1}
     * @memberof ControlDetectionWithEntities
     */
    integrationPlatform: ControlIntegrationPlatform1;
    /**
     * 
     * @type {Array<ControlIP>}
     * @memberof ControlDetectionWithEntities
     */
    ips: Array<ControlIP>;
    /**
     * 
     * @type {string}
     * @memberof ControlDetectionWithEntities
     */
    lastRefreshAt?: string;
    /**
     * 
     * @type {Array<ControlLocation>}
     * @memberof ControlDetectionWithEntities
     */
    locations: Array<ControlLocation>;
    /**
     * 
     * @type {Array<ControlJSONLog>}
     * @memberof ControlDetectionWithEntities
     */
    logs: Array<ControlJSONLog>;
    /**
     * 
     * @type {boolean}
     * @memberof ControlDetectionWithEntities
     */
    managedByThirdParty: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlDetectionWithEntities
     */
    nextSteps?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDetectionWithEntities
     */
    notes?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ControlDetectionWithEntities
     */
    ocsfDetectionFinding: { [key: string]: any; };
    /**
     * 
     * @type {boolean}
     * @memberof ControlDetectionWithEntities
     */
    prevented: boolean;
    /**
     * 
     * @type {Array<ControlProcess>}
     * @memberof ControlDetectionWithEntities
     */
    processes: Array<ControlProcess>;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ControlDetectionWithEntities
     */
    raw: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ControlDetectionWithEntities
     */
    refreshRaw?: { [key: string]: any; };
    /**
     * 
     * @type {boolean}
     * @memberof ControlDetectionWithEntities
     */
    reingested: boolean;
    /**
     * 
     * @type {ControlSeverity5}
     * @memberof ControlDetectionWithEntities
     */
    severity: ControlSeverity5;
    /**
     * 
     * @type {number}
     * @memberof ControlDetectionWithEntities
     */
    severityOrdinal: number;
    /**
     * 
     * @type {string}
     * @memberof ControlDetectionWithEntities
     */
    sid: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDetectionWithEntities
     */
    sourceDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDetectionWithEntities
     */
    sourceDetectedAt: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDetectionWithEntities
     */
    sourceIngestedAt: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDetectionWithEntities
     */
    sourceName?: string;
    /**
     * 
     * @type {ControlStatus3}
     * @memberof ControlDetectionWithEntities
     */
    status: ControlStatus3;
    /**
     * 
     * @type {string}
     * @memberof ControlDetectionWithEntities
     */
    teamId: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDetectionWithEntities
     */
    teamName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlDetectionWithEntities
     */
    testMode: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlDetectionWithEntities
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDetectionWithEntities
     */
    updatedAt?: string;
    /**
     * 
     * @type {Array<ControlUserAgent>}
     * @memberof ControlDetectionWithEntities
     */
    userAgents: Array<ControlUserAgent>;
    /**
     * 
     * @type {ControlVerdict4}
     * @memberof ControlDetectionWithEntities
     */
    verdict: ControlVerdict4;
    /**
     * 
     * @type {ControlVerdictRule}
     * @memberof ControlDetectionWithEntities
     */
    verdictSetting?: ControlVerdictRule;
    /**
     * 
     * @type {string}
     * @memberof ControlDetectionWithEntities
     */
    verdictedAt?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlDetectionWithEntities
     */
    wasEscalated: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlDetectionWithEntities
     */
    whatHappened: string;
}

/**
 * Check if a given object implements the ControlDetectionWithEntities interface.
 */
export function instanceOfControlDetectionWithEntities(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "category" in value;
    isInstance = isInstance && "chatOpsActions" in value;
    isInstance = isInstance && "chatOpsTest" in value;
    isInstance = isInstance && "containOnChatOpsFailure" in value;
    isInstance = isInstance && "contained" in value;
    isInstance = isInstance && "containmentActions" in value;
    isInstance = isInstance && "containments" in value;
    isInstance = isInstance && "containsHVA" in value;
    isInstance = isInstance && "containsVIP" in value;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "directory" in value;
    isInstance = isInstance && "domains" in value;
    isInstance = isInstance && "endpoints" in value;
    isInstance = isInstance && "excludeFromMeans" in value;
    isInstance = isInstance && "excluded" in value;
    isInstance = isInstance && "fileRisk" in value;
    isInstance = isInstance && "files" in value;
    isInstance = isInstance && "firstRun" in value;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "integrationPlatform" in value;
    isInstance = isInstance && "ips" in value;
    isInstance = isInstance && "locations" in value;
    isInstance = isInstance && "logs" in value;
    isInstance = isInstance && "managedByThirdParty" in value;
    isInstance = isInstance && "ocsfDetectionFinding" in value;
    isInstance = isInstance && "prevented" in value;
    isInstance = isInstance && "processes" in value;
    isInstance = isInstance && "raw" in value;
    isInstance = isInstance && "reingested" in value;
    isInstance = isInstance && "severity" in value;
    isInstance = isInstance && "severityOrdinal" in value;
    isInstance = isInstance && "sid" in value;
    isInstance = isInstance && "sourceDetectedAt" in value;
    isInstance = isInstance && "sourceIngestedAt" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "teamId" in value;
    isInstance = isInstance && "testMode" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "userAgents" in value;
    isInstance = isInstance && "verdict" in value;
    isInstance = isInstance && "wasEscalated" in value;
    isInstance = isInstance && "whatHappened" in value;

    return isInstance;
}

export function ControlDetectionWithEntitiesFromJSON(json: any): ControlDetectionWithEntities {
    return ControlDetectionWithEntitiesFromJSONTyped(json, false);
}

export function ControlDetectionWithEntitiesFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlDetectionWithEntities {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'actionSlug': !exists(json, 'actionSlug') ? undefined : json['actionSlug'],
        'autoClosed': !exists(json, 'autoClosed') ? undefined : json['autoClosed'],
        'autoContained': !exists(json, 'autoContained') ? undefined : json['autoContained'],
        'caseId': !exists(json, 'caseId') ? undefined : json['caseId'],
        'caseSid': !exists(json, 'caseSid') ? undefined : json['caseSid'],
        'category': ControlCategory3FromJSON(json['category']),
        'chatOpsActions': ((json['chatOpsActions'] as Array<any>).map(ControlActionChatopsFromJSON)),
        'chatOpsTest': json['chatOpsTest'],
        'chatOpsTestEmail': !exists(json, 'chatOpsTestEmail') ? undefined : json['chatOpsTestEmail'],
        'chatOpsTestPhoneNumber': !exists(json, 'chatOpsTestPhoneNumber') ? undefined : json['chatOpsTestPhoneNumber'],
        'closedAt': !exists(json, 'closedAt') ? undefined : json['closedAt'],
        'containOnChatOpsFailure': json['containOnChatOpsFailure'],
        'contained': json['contained'],
        'containmentActions': ((json['containmentActions'] as Array<any>).map(ControlActionContainWithUserFromJSON)),
        'containments': ((json['containments'] as Array<any>).map(ControlContainmentFromJSON)),
        'containsHVA': json['containsHVA'],
        'containsVIP': json['containsVIP'],
        'createdAt': json['createdAt'],
        'customDetectionId': !exists(json, 'customDetectionId') ? undefined : json['customDetectionId'],
        'directory': ((json['directory'] as Array<any>).map(ControlDirectoryUserFromJSON)),
        'domains': ((json['domains'] as Array<any>).map(ControlDomainFromJSON)),
        'duplicateDetectionId': !exists(json, 'duplicateDetectionId') ? undefined : json['duplicateDetectionId'],
        'endpoints': ((json['endpoints'] as Array<any>).map(ControlEndpointFromJSON)),
        'escalatedAt': !exists(json, 'escalatedAt') ? undefined : json['escalatedAt'],
        'excludeFromMeans': json['excludeFromMeans'],
        'excluded': json['excluded'],
        'exclusionId': !exists(json, 'exclusionId') ? undefined : json['exclusionId'],
        'exclusionSid': !exists(json, 'exclusionSid') ? undefined : json['exclusionSid'],
        'externalCustomDetectionId': !exists(json, 'externalCustomDetectionId') ? undefined : json['externalCustomDetectionId'],
        'fileRisk': ControlFileRiskFromJSON(json['fileRisk']),
        'files': ((json['files'] as Array<any>).map(ControlFileFromJSON)),
        'firstRun': json['firstRun'],
        'groups': !exists(json, 'groups') ? undefined : json['groups'],
        'id': json['id'],
        'integrationId': !exists(json, 'integrationId') ? undefined : json['integrationId'],
        'integrationPlatform': ControlIntegrationPlatform1FromJSON(json['integrationPlatform']),
        'ips': ((json['ips'] as Array<any>).map(ControlIPFromJSON)),
        'lastRefreshAt': !exists(json, 'lastRefreshAt') ? undefined : json['lastRefreshAt'],
        'locations': ((json['locations'] as Array<any>).map(ControlLocationFromJSON)),
        'logs': ((json['logs'] as Array<any>).map(ControlJSONLogFromJSON)),
        'managedByThirdParty': json['managedByThirdParty'],
        'nextSteps': !exists(json, 'nextSteps') ? undefined : json['nextSteps'],
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
        'ocsfDetectionFinding': json['ocsfDetectionFinding'],
        'prevented': json['prevented'],
        'processes': ((json['processes'] as Array<any>).map(ControlProcessFromJSON)),
        'raw': json['raw'],
        'refreshRaw': !exists(json, 'refreshRaw') ? undefined : json['refreshRaw'],
        'reingested': json['reingested'],
        'severity': ControlSeverity5FromJSON(json['severity']),
        'severityOrdinal': json['severityOrdinal'],
        'sid': json['sid'],
        'sourceDescription': !exists(json, 'sourceDescription') ? undefined : json['sourceDescription'],
        'sourceDetectedAt': json['sourceDetectedAt'],
        'sourceIngestedAt': json['sourceIngestedAt'],
        'sourceName': !exists(json, 'sourceName') ? undefined : json['sourceName'],
        'status': ControlStatus3FromJSON(json['status']),
        'teamId': json['teamId'],
        'teamName': !exists(json, 'teamName') ? undefined : json['teamName'],
        'testMode': json['testMode'],
        'title': json['title'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : json['updatedAt'],
        'userAgents': ((json['userAgents'] as Array<any>).map(ControlUserAgentFromJSON)),
        'verdict': ControlVerdict4FromJSON(json['verdict']),
        'verdictSetting': !exists(json, 'verdictSetting') ? undefined : ControlVerdictRuleFromJSON(json['verdictSetting']),
        'verdictedAt': !exists(json, 'verdictedAt') ? undefined : json['verdictedAt'],
        'wasEscalated': json['wasEscalated'],
        'whatHappened': json['whatHappened'],
    };
}

export function ControlDetectionWithEntitiesToJSON(value?: ControlDetectionWithEntities | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'actionSlug': value.actionSlug,
        'autoClosed': value.autoClosed,
        'autoContained': value.autoContained,
        'caseId': value.caseId,
        'caseSid': value.caseSid,
        'category': ControlCategory3ToJSON(value.category),
        'chatOpsActions': ((value.chatOpsActions as Array<any>).map(ControlActionChatopsToJSON)),
        'chatOpsTest': value.chatOpsTest,
        'chatOpsTestEmail': value.chatOpsTestEmail,
        'chatOpsTestPhoneNumber': value.chatOpsTestPhoneNumber,
        'closedAt': value.closedAt,
        'containOnChatOpsFailure': value.containOnChatOpsFailure,
        'contained': value.contained,
        'containmentActions': ((value.containmentActions as Array<any>).map(ControlActionContainWithUserToJSON)),
        'containments': ((value.containments as Array<any>).map(ControlContainmentToJSON)),
        'containsHVA': value.containsHVA,
        'containsVIP': value.containsVIP,
        'createdAt': value.createdAt,
        'customDetectionId': value.customDetectionId,
        'directory': ((value.directory as Array<any>).map(ControlDirectoryUserToJSON)),
        'domains': ((value.domains as Array<any>).map(ControlDomainToJSON)),
        'duplicateDetectionId': value.duplicateDetectionId,
        'endpoints': ((value.endpoints as Array<any>).map(ControlEndpointToJSON)),
        'escalatedAt': value.escalatedAt,
        'excludeFromMeans': value.excludeFromMeans,
        'excluded': value.excluded,
        'exclusionId': value.exclusionId,
        'exclusionSid': value.exclusionSid,
        'externalCustomDetectionId': value.externalCustomDetectionId,
        'fileRisk': ControlFileRiskToJSON(value.fileRisk),
        'files': ((value.files as Array<any>).map(ControlFileToJSON)),
        'firstRun': value.firstRun,
        'groups': value.groups,
        'id': value.id,
        'integrationId': value.integrationId,
        'integrationPlatform': ControlIntegrationPlatform1ToJSON(value.integrationPlatform),
        'ips': ((value.ips as Array<any>).map(ControlIPToJSON)),
        'lastRefreshAt': value.lastRefreshAt,
        'locations': ((value.locations as Array<any>).map(ControlLocationToJSON)),
        'logs': ((value.logs as Array<any>).map(ControlJSONLogToJSON)),
        'managedByThirdParty': value.managedByThirdParty,
        'nextSteps': value.nextSteps,
        'notes': value.notes,
        'ocsfDetectionFinding': value.ocsfDetectionFinding,
        'prevented': value.prevented,
        'processes': ((value.processes as Array<any>).map(ControlProcessToJSON)),
        'raw': value.raw,
        'refreshRaw': value.refreshRaw,
        'reingested': value.reingested,
        'severity': ControlSeverity5ToJSON(value.severity),
        'severityOrdinal': value.severityOrdinal,
        'sid': value.sid,
        'sourceDescription': value.sourceDescription,
        'sourceDetectedAt': value.sourceDetectedAt,
        'sourceIngestedAt': value.sourceIngestedAt,
        'sourceName': value.sourceName,
        'status': ControlStatus3ToJSON(value.status),
        'teamId': value.teamId,
        'teamName': value.teamName,
        'testMode': value.testMode,
        'title': value.title,
        'updatedAt': value.updatedAt,
        'userAgents': ((value.userAgents as Array<any>).map(ControlUserAgentToJSON)),
        'verdict': ControlVerdict4ToJSON(value.verdict),
        'verdictSetting': ControlVerdictRuleToJSON(value.verdictSetting),
        'verdictedAt': value.verdictedAt,
        'wasEscalated': value.wasEscalated,
        'whatHappened': value.whatHappened,
    };
}

